"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const NativeSelect_1 = __importDefault(require("../../common/js/atoms/NativeSelect"));
const LoadingSpinner_1 = __importDefault(require("../../common/js/components/LoadingSpinner"));
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const NativeSelectTypes_1 = __importDefault(require("../../common/js/enums/NativeSelectTypes"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const LineItemPrice_1 = __importDefault(require("../atoms/LineItemPrice"));
const NumberStepper_1 = __importDefault(require("../atoms/NumberStepper"));
const Paths_1 = require("../constants/Paths");
const lineItem_1 = require("../helper/lineItem");
const media_1 = require("../helper/media");
const money_1 = require("../helper/money");
const path_1 = require("../helper/path");
const product_1 = require("../helper/product");
class CartListItem extends react_1.default.Component {
    debouncedOnQuantityChanged = (0, debounce_1.debounce)(this.onQuantityChanged, 500);
    loading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            onQuantityChanged: mobx_1.action.bound,
        });
    }
    render() {
        const { lineItem, product, onDelete } = this.props;
        const payload = lineItem.payload ?? {};
        const minQuantity = product && product.id ? Math.max(1, product.minPurchase ?? 0) : 1;
        const quantityOptions = product && product.id ? (0, product_1.getQuantityOptions)(minQuantity, product) : {};
        const isSoftwareLineItem = null !== (payload.massiveAdditionalSeatsCount ?? null) || null !== (payload.zkpSoftwareOfferId ?? null);
        const payloadDescriptions = (0, lineItem_1.getLineItemPayloadDescriptions)(lineItem);
        const currency = product?.extensions?.zkpProductData?.currencyIsoCode ?? '';
        const canUpdateCart = AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.CART_UPDATE);
        return (react_1.default.createElement(react_1.default.Fragment, null, product && product.id ? (react_1.default.createElement("div", { className: "znd-cart-list-item d-flex flex-row align-items-start align-items-lg-center" },
            react_1.default.createElement(react_router_dom_1.Link, { className: "znd-cart-list-item__image-wrapper", to: (0, path_1.localePath)(Paths_1.PATH_SHOP_PRODUCT).replace(':product', product.productNumber) }, product.cover?.media ? (react_1.default.createElement("img", { className: "znd-cart-list-item__image", ...(0, media_1.imageSourceFromMedia)(product.cover.media), alt: product.cover.media.alt })) : null),
            react_1.default.createElement("div", { className: "znd-cart-list-item__content-wrapper d-flex flex-column flex-lg-row flex-lg-grow-1 align-items-lg-center" },
                react_1.default.createElement("div", { className: "znd-cart-list-item__text-wrapper d-flex flex-column" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths_1.PATH_SHOP_PRODUCT).replace(':product', product.productNumber), className: "znd-cart-list-item__title t-subhead-small" }, product.translated?.name),
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-cart-list-item__description', 't-body-small', {
                            'd-block text-wrap': payloadDescriptions.length > 0,
                        }) }, payloadDescriptions.length > 0
                        ? payloadDescriptions.map((value) => (react_1.default.createElement("div", { key: `description-${value}` }, value)))
                        : product.translated?.description)),
                react_1.default.createElement("div", { className: "znd-cart-list-item__price d-none d-lg-flex flex-row align-items-end flex-lg-column align-items-lg-end" },
                    (0, product_1.showPrices)(product) && !product.extensions?.massiveDeferPriceDisplay?.defer ? (react_1.default.createElement("div", { className: "znd-cart-list-item__price-amount" },
                        react_1.default.createElement(LineItemPrice_1.default, { currency: currency, lineItem: lineItem }))) : null,
                    (product.purchaseUnit ?? 0) > 1 ? (react_1.default.createElement("div", { className: "znd-cart-list-item__price-per-unit t-body-small" },
                        ' ',
                        (0, translation_1.t)('product_page.a_unit', {
                            amount: product.purchaseUnit,
                            unit: product.unit?.translated?.name ?? '',
                        }))) : null),
                react_1.default.createElement("div", { className: "znd-cart-list-item__number-stepper" }, (product.purchaseSteps ?? 1) > 1 ? (react_1.default.createElement(NativeSelect_1.default, { placeholder: String(minQuantity), value: String(lineItem.quantity), options: quantityOptions, alwaysShowPlaceholder: false, disabled: this.loading || !canUpdateCart, type: NativeSelectTypes_1.default.cartLineItemQuantity, onChange: (value) => {
                        const quantity = parseInt(value);
                        lineItem.quantity = quantity;
                        this.onQuantityChanged(quantity);
                    } })) : (react_1.default.createElement(NumberStepper_1.default, { value: lineItem.quantity ?? 1, onChange: (0, mobx_1.action)((quantity) => {
                        lineItem.quantity = quantity;
                        this.debouncedOnQuantityChanged(quantity);
                    }), min: minQuantity, max: (0, product_1.getMaxPurchase)(product), disabled: isSoftwareLineItem || !canUpdateCart }))),
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.text, icon: Zupicons_1.default.trash, className: (0, classnames_1.default)('znd-cart-list-item__button-trash', {
                        'mr-4': !(0, product_1.showPrices)(product),
                    }), onClick: (0, mobx_1.action)(() => {
                        if (!lineItem.id) {
                            return;
                        }
                        this.loading = true;
                        onDelete(lineItem.id).finally((0, mobx_1.action)(() => {
                            this.loading = false;
                        }));
                    }), loading: this.loading, disabled: !canUpdateCart }),
                (0, product_1.showPrices)(product) ? (react_1.default.createElement("div", { className: "znd-cart-list-item__price-total" }, !!product.extensions?.massiveDeferPriceDisplay?.defer ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-loading-spinner--small" })) : ((0, money_1.moneyFormat)(lineItem.price?.totalPrice ?? 0, currency)))) : null))) : null));
    }
    onQuantityChanged(quantity) {
        const { onQuantityChange, lineItem } = this.props;
        if (!lineItem.id) {
            return;
        }
        this.loading = true;
        onQuantityChange(lineItem.id, quantity).finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
}
exports.default = (0, mobx_react_1.observer)(CartListItem);
